import React from "react";
import { InputGroup, FormControl, Dropdown } from "react-bootstrap";
import { FaSearch, FaFilter } from "react-icons/fa";

const ClientFilters = ({
  searchQuery,
  setSearchQuery,
  stepFilter,
  setStepFilter,
  serviceFilter,
  setServiceFilter,
  paymentFilter,
  setPaymentFilter,
}) => {
  return (
    <div className="mb-3 d-flex flex-wrap gap-3">
      <div style={{ width: "300px" }}>
        <InputGroup>
          <InputGroup.Text>
            <FaSearch />
          </InputGroup.Text>
          <FormControl
            placeholder="Search by name or email"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </InputGroup>
      </div>

      <Dropdown>
        <Dropdown.Toggle variant="secondary" id="dropdown-service-filter">
          <FaFilter /> Service: {serviceFilter === "all" ? "All" : 
            serviceFilter === "usa" ? "USA Company" :
            serviceFilter === "tax" ? "Tax Filing" :
            serviceFilter === "bookkeeping" ? "Bookkeeping" :
            serviceFilter === "cfo" ? "CFO Advisory" :
            serviceFilter === "registeredAgent" ? "Registered Agent" : serviceFilter}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => setServiceFilter("all")}>All Services</Dropdown.Item>
          <Dropdown.Item onClick={() => setServiceFilter("usa")}>USA Company</Dropdown.Item>
          <Dropdown.Item onClick={() => setServiceFilter("tax")}>Tax Filing</Dropdown.Item>
          <Dropdown.Item onClick={() => setServiceFilter("bookkeeping")}>Bookkeeping</Dropdown.Item>
          <Dropdown.Item onClick={() => setServiceFilter("cfo")}>CFO Advisory</Dropdown.Item>
          <Dropdown.Item onClick={() => setServiceFilter("registeredAgent")}>Registered Agent</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <Dropdown>
        <Dropdown.Toggle variant="secondary" id="dropdown-step-filter">
          <FaFilter /> Steps: {stepFilter === "all" ? "All" :
            stepFilter === "1" ? "Step 1" :
            stepFilter === "2" ? "Step 2" :
            stepFilter === "3" ? "Step 3" :
            stepFilter === "4" ? "Step 4" : stepFilter}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => setStepFilter("all")}>All Steps</Dropdown.Item>
          <Dropdown.Item onClick={() => setStepFilter("1")}>Step 1</Dropdown.Item>
          <Dropdown.Item onClick={() => setStepFilter("2")}>Step 2</Dropdown.Item>
          <Dropdown.Item onClick={() => setStepFilter("3")}>Step 3</Dropdown.Item>
          <Dropdown.Item onClick={() => setStepFilter("4")}>Step 4</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <Dropdown>
        <Dropdown.Toggle variant="secondary" id="dropdown-payment-filter">
          <FaFilter /> Payment: {paymentFilter === "all" ? "All" : 
            paymentFilter === "paid" ? "Paid" : "Unpaid"}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => setPaymentFilter("all")}>All Payments</Dropdown.Item>
          <Dropdown.Item onClick={() => setPaymentFilter("paid")}>Paid</Dropdown.Item>
          <Dropdown.Item onClick={() => setPaymentFilter("unpaid")}>Unpaid</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default ClientFilters;
